export default "__VITE_ASSET__Bmn4Q4kY__"